
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  Session: 'Session',
  Account: 'Account',
  Verification: 'Verification',
  RegionContract: 'RegionContract',
  Region: 'Region',
  RegionUpload: 'RegionUpload',
  RegionCategoryAssignment: 'RegionCategoryAssignment',
  RegionBackgroundAssignment: 'RegionBackgroundAssignment',
  PrivateBackgroundSource: 'PrivateBackgroundSource',
  RegionExportAssignment: 'RegionExportAssignment',
  RegionNavigationLink: 'RegionNavigationLink',
  RegionConfigTemplate: 'RegionConfigTemplate',
  AuditLog: 'AuditLog',
  AdminApiToken: 'AdminApiToken',
  ExternalApiToken: 'ExternalApiToken',
  Membership: 'Membership',
  MapDatasetUpload: 'MapDatasetUpload',
  MapDatasetLayerConfig: 'MapDatasetLayerConfig',
  MapDatasetCategory: 'MapDatasetCategory',
  Note: 'Note',
  NoteFolder: 'NoteFolder',
  NoteComment: 'NoteComment',
  ReviewList: 'ReviewList',
  ReviewEntry: 'ReviewEntry',
  ReviewEntryComment: 'ReviewEntryComment',
  QaConfig: 'QaConfig',
  QaEvaluation: 'QaEvaluation',
  DataSchemaImport: 'DataSchemaImport',
  MapLayerOrder: 'MapLayerOrder'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  emailVerified: 'emailVerified',
  osmId: 'osmId',
  osmName: 'osmName',
  osmDescription: 'osmDescription',
  osmAvatar: 'osmAvatar',
  firstName: 'firstName',
  lastName: 'lastName',
  role: 'role',
  accessedRegions: 'accessedRegions'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  expiresAt: 'expiresAt',
  token: 'token',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const AccountScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const VerificationScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  value: 'value',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
} as const

export type VerificationScalarFieldEnum = (typeof VerificationScalarFieldEnum)[keyof typeof VerificationScalarFieldEnum]


export const RegionContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  name: 'name',
  status: 'status'
} as const

export type RegionContractScalarFieldEnum = (typeof RegionContractScalarFieldEnum)[keyof typeof RegionContractScalarFieldEnum]


export const RegionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  promoted: 'promoted',
  status: 'status',
  name: 'name',
  fullName: 'fullName',
  product: 'product',
  notesOsm: 'notesOsm',
  notesInternal: 'notesInternal',
  showSearch: 'showSearch',
  mapLat: 'mapLat',
  mapLng: 'mapLng',
  mapZoom: 'mapZoom',
  logoWhiteBackgroundRequired: 'logoWhiteBackgroundRequired',
  headerLogoId: 'headerLogoId',
  maskOsmRelationIds: 'maskOsmRelationIds',
  maskBufferKm: 'maskBufferKm',
  bbox: 'bbox',
  cacheWarming: 'cacheWarming',
  contractId: 'contractId',
  welcomeEnabled: 'welcomeEnabled',
  welcomeTitle: 'welcomeTitle',
  welcomeSubtitle: 'welcomeSubtitle',
  welcomeBodyMarkdown: 'welcomeBodyMarkdown',
  welcomeSections: 'welcomeSections',
  welcomeImageUploadId: 'welcomeImageUploadId',
  welcomeImageAltText: 'welcomeImageAltText'
} as const

export type RegionScalarFieldEnum = (typeof RegionScalarFieldEnum)[keyof typeof RegionScalarFieldEnum]


export const RegionUploadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  s3Key: 's3Key',
  mimeType: 'mimeType',
  fileSize: 'fileSize',
  regionId: 'regionId',
  createdById: 'createdById'
} as const

export type RegionUploadScalarFieldEnum = (typeof RegionUploadScalarFieldEnum)[keyof typeof RegionUploadScalarFieldEnum]


export const RegionCategoryAssignmentScalarFieldEnum = {
  id: 'id',
  regionId: 'regionId',
  categoryId: 'categoryId',
  sortOrder: 'sortOrder'
} as const

export type RegionCategoryAssignmentScalarFieldEnum = (typeof RegionCategoryAssignmentScalarFieldEnum)[keyof typeof RegionCategoryAssignmentScalarFieldEnum]


export const RegionBackgroundAssignmentScalarFieldEnum = {
  id: 'id',
  regionId: 'regionId',
  sourceId: 'sourceId'
} as const

export type RegionBackgroundAssignmentScalarFieldEnum = (typeof RegionBackgroundAssignmentScalarFieldEnum)[keyof typeof RegionBackgroundAssignmentScalarFieldEnum]


export const PrivateBackgroundSourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  name: 'name',
  tilesUrl: 'tilesUrl',
  tilesUrlChangedAt: 'tilesUrlChangedAt',
  attributionHtml: 'attributionHtml',
  minzoom: 'minzoom',
  maxzoom: 'maxzoom',
  tileSize: 'tileSize'
} as const

export type PrivateBackgroundSourceScalarFieldEnum = (typeof PrivateBackgroundSourceScalarFieldEnum)[keyof typeof PrivateBackgroundSourceScalarFieldEnum]


export const RegionExportAssignmentScalarFieldEnum = {
  id: 'id',
  regionId: 'regionId',
  exportId: 'exportId'
} as const

export type RegionExportAssignmentScalarFieldEnum = (typeof RegionExportAssignmentScalarFieldEnum)[keyof typeof RegionExportAssignmentScalarFieldEnum]


export const RegionNavigationLinkScalarFieldEnum = {
  id: 'id',
  regionId: 'regionId',
  name: 'name',
  internalPath: 'internalPath',
  externalUrl: 'externalUrl',
  sortOrder: 'sortOrder'
} as const

export type RegionNavigationLinkScalarFieldEnum = (typeof RegionNavigationLinkScalarFieldEnum)[keyof typeof RegionNavigationLinkScalarFieldEnum]


export const RegionConfigTemplateScalarFieldEnum = {
  checksum: 'checksum',
  template: 'template',
  createdAt: 'createdAt'
} as const

export type RegionConfigTemplateScalarFieldEnum = (typeof RegionConfigTemplateScalarFieldEnum)[keyof typeof RegionConfigTemplateScalarFieldEnum]


export const AuditLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  recordId: 'recordId',
  action: 'action',
  model: 'model',
  oldData: 'oldData',
  newData: 'newData',
  changedFields: 'changedFields',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  metadata: 'metadata',
  createdAt: 'createdAt'
} as const

export type AuditLogScalarFieldEnum = (typeof AuditLogScalarFieldEnum)[keyof typeof AuditLogScalarFieldEnum]


export const AdminApiTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  hashedToken: 'hashedToken',
  lastUsedAt: 'lastUsedAt',
  revokedAt: 'revokedAt',
  createdById: 'createdById'
} as const

export type AdminApiTokenScalarFieldEnum = (typeof AdminApiTokenScalarFieldEnum)[keyof typeof AdminApiTokenScalarFieldEnum]


export const ExternalApiTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  hashedToken: 'hashedToken',
  scope: 'scope',
  expiresAt: 'expiresAt',
  lastUsedAt: 'lastUsedAt',
  userId: 'userId'
} as const

export type ExternalApiTokenScalarFieldEnum = (typeof ExternalApiTokenScalarFieldEnum)[keyof typeof ExternalApiTokenScalarFieldEnum]


export const MembershipScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  regionId: 'regionId'
} as const

export type MembershipScalarFieldEnum = (typeof MembershipScalarFieldEnum)[keyof typeof MembershipScalarFieldEnum]


export const MapDatasetUploadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  updatedAt: 'updatedAt',
  slug: 'slug',
  configs: 'configs',
  public: 'public',
  hideDownloadLink: 'hideDownloadLink',
  mapRenderFormat: 'mapRenderFormat',
  mapRenderUrl: 'mapRenderUrl',
  githubUrl: 'githubUrl',
  pmtilesUrl: 'pmtilesUrl',
  geojsonUrl: 'geojsonUrl',
  externalSourceUrl: 'externalSourceUrl',
  cacheTtlSeconds: 'cacheTtlSeconds',
  systemLayer: 'systemLayer',
  attributionHtml: 'attributionHtml',
  dataSourceMarkdown: 'dataSourceMarkdown',
  dataUpdatedNote: 'dataUpdatedNote',
  licence: 'licence',
  licenceOsmCompatible: 'licenceOsmCompatible'
} as const

export type MapDatasetUploadScalarFieldEnum = (typeof MapDatasetUploadScalarFieldEnum)[keyof typeof MapDatasetUploadScalarFieldEnum]


export const MapDatasetLayerConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mapDatasetUploadId: 'mapDatasetUploadId',
  subId: 'subId',
  name: 'name',
  categoryKey: 'categoryKey',
  layers: 'layers',
  inspector: 'inspector',
  legends: 'legends',
  osmIdConfig: 'osmIdConfig',
  description: 'description'
} as const

export type MapDatasetLayerConfigScalarFieldEnum = (typeof MapDatasetLayerConfigScalarFieldEnum)[keyof typeof MapDatasetLayerConfigScalarFieldEnum]


export const MapDatasetCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  groupKey: 'groupKey',
  categoryKey: 'categoryKey',
  sortOrder: 'sortOrder',
  title: 'title',
  subtitle: 'subtitle'
} as const

export type MapDatasetCategoryScalarFieldEnum = (typeof MapDatasetCategoryScalarFieldEnum)[keyof typeof MapDatasetCategoryScalarFieldEnum]


export const NoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  folderId: 'folderId',
  subject: 'subject',
  body: 'body',
  resolvedAt: 'resolvedAt',
  latitude: 'latitude',
  longitude: 'longitude'
} as const

export type NoteScalarFieldEnum = (typeof NoteScalarFieldEnum)[keyof typeof NoteScalarFieldEnum]


export const NoteFolderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type NoteFolderScalarFieldEnum = (typeof NoteFolderScalarFieldEnum)[keyof typeof NoteFolderScalarFieldEnum]


export const NoteCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  noteId: 'noteId',
  body: 'body'
} as const

export type NoteCommentScalarFieldEnum = (typeof NoteCommentScalarFieldEnum)[keyof typeof NoteCommentScalarFieldEnum]


export const ReviewListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type ReviewListScalarFieldEnum = (typeof ReviewListScalarFieldEnum)[keyof typeof ReviewListScalarFieldEnum]


export const ReviewEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listId: 'listId',
  geometry: 'geometry',
  geometryType: 'geometryType',
  properties: 'properties',
  importId: 'importId',
  source: 'source',
  sourceMeta: 'sourceMeta',
  createdById: 'createdById',
  updatedById: 'updatedById',
  status: 'status'
} as const

export type ReviewEntryScalarFieldEnum = (typeof ReviewEntryScalarFieldEnum)[keyof typeof ReviewEntryScalarFieldEnum]


export const ReviewEntryCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  entryId: 'entryId',
  body: 'body'
} as const

export type ReviewEntryCommentScalarFieldEnum = (typeof ReviewEntryCommentScalarFieldEnum)[keyof typeof ReviewEntryCommentScalarFieldEnum]


export const QaConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  label: 'label',
  isActive: 'isActive',
  mapTable: 'mapTable',
  mapAttribution: 'mapAttribution',
  dataset: 'dataset',
  areaTable: 'areaTable',
  areaFilter: 'areaFilter',
  referenceTable: 'referenceTable',
  indicators: 'indicators',
  trustedOsmUsernames: 'trustedOsmUsernames',
  referenceFrozenAt: 'referenceFrozenAt',
  regionId: 'regionId'
} as const

export type QaConfigScalarFieldEnum = (typeof QaConfigScalarFieldEnum)[keyof typeof QaConfigScalarFieldEnum]


export const QaEvaluationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  areaId: 'areaId',
  indicatorKey: 'indicatorKey',
  systemStatus: 'systemStatus',
  userStatus: 'userStatus',
  body: 'body',
  decisionData: 'decisionData',
  configId: 'configId',
  evaluatorType: 'evaluatorType',
  userId: 'userId'
} as const

export type QaEvaluationScalarFieldEnum = (typeof QaEvaluationScalarFieldEnum)[keyof typeof QaEvaluationScalarFieldEnum]


export const DataSchemaImportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tableName: 'tableName',
  publishedAt: 'publishedAt',
  snapshotId: 'snapshotId',
  sha256: 'sha256',
  status: 'status',
  rowCount: 'rowCount',
  durationMs: 'durationMs',
  errorText: 'errorText',
  createdById: 'createdById',
  updatedById: 'updatedById'
} as const

export type DataSchemaImportScalarFieldEnum = (typeof DataSchemaImportScalarFieldEnum)[keyof typeof DataSchemaImportScalarFieldEnum]


export const MapLayerOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  layerKey: 'layerKey',
  position: 'position',
  beforeId: 'beforeId'
} as const

export type MapLayerOrderScalarFieldEnum = (typeof MapLayerOrderScalarFieldEnum)[keyof typeof MapLayerOrderScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]

